import { GroupTargets, STargets } from '../types';

export const isGardStatisticsGroup = (
  p: STargets | GroupTargets,
): p is GroupTargets => true;

export const isGardStatistics = (p: STargets | GroupTargets): p is STargets =>
  true;
